import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=d8a327c2&scoped=true&"
import script from "./SidePanel.vue?vue&type=script&lang=ts&"
export * from "./SidePanel.vue?vue&type=script&lang=ts&"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=d8a327c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a327c2",
  null
  
)

export default component.exports